(function () {
    let editors = Array.from(document.querySelectorAll('.prose-editor'));
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // Should be imported from tailwind config, this is a quick fix
    const breakpoints = {
        xs: '480px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        '2xl': '1536px',
    };

    resizeImages(editors);

    function resizeImages(containers) {
        if (windowWidth < breakpointStringToInteger(breakpoints.sm)) {
            containers.forEach((container) => {
                let images = Array.from(container.querySelectorAll('img'));

                images.forEach((image) => {
                    if (image.complete) {
                        scaleImageToContainer(container, image);
                    } else {
                        image.addEventListener('load', () => {
                            scaleImageToContainer(container, image);
                        });
                    }
                });
            });
        }
    }

    function breakpointStringToInteger(string) {
        return parseInt(string.replace('px', ''));
    }

    function scaleImageToContainer(container, image) {
        let containerWidth = container.getBoundingClientRect().width;

        if (image.naturalWidth >= containerWidth) {
            image.style.width = '100%';
        } else {
            image.style.width = image.naturalWidth + 'px';
        }
    }
})();
